export default __webpack_public_path__ + "static/media/cinema.09a20983.svg";